import React from 'react';
import { LatLng } from 'leaflet';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from '../actions';

import camelCase from 'lodash/camelCase';
import differenceBy from 'lodash/differenceBy';

import AbstractMapView from './AbstractMapView';
import { getPorTipo, MarkerCamera, MarkerCameraOff } from '../components/mapa/Marker';

import CardCamera from '../components/CardCamera';

const UM_MINUTO = 62000;
  
class Marcadores extends AbstractMapView {
  registerListener() {
    this.props.registerAlertasListeners();
    this.props.registerCamerasListeners();
  }

  unregisterListener() {
    this.props.unregisterAlertasListeners();
    this.props.resetAlertas();
    this.props.unregisterCamerasListeners();
    this.props.resetCameras();
  }

  render() {
    const cameraSelecionada = this.props.cameraSelecionada;
    const selecionaCamera = this.props.selecionaCamera;

    return (
      <div>
        {
          cameraSelecionada.key &&
          <CardCamera
            camera={ cameraSelecionada }
            camerasProximas={ this.getCamerasProximas() }
            selecionaCamera={ this.selecionaCamera2.bind(this) }
            onClose={ selecionaCamera.bind(this, {}) }
            videoUrl={ this.props.videoUrl }
            viajar={ this.viajar.bind(this) }
            despublicar={ this.despublicarCamera.bind(this) }
          />
        }
        <div id="main-map"></div>
      </div>
    );
  }

  despublicarCamera(camera) {
    this.props.selecionaCamera({});
    this.props.removerPublicOnCop(camera);
  }

  viajar(coordenadas, zoom){
    return this.viajarAte(new LatLng(coordenadas[0], coordenadas[1]), zoom);
  }

  getCamerasProximas() {
    const { cameras, cameraSelecionada } = this.props;

    if (Array.isArray(cameraSelecionada.coordenadas)) {
      const [refLat, refLng] = cameraSelecionada.coordenadas;
      const ref = new LatLng(refLat, refLng);

      return cameras
        .map(camera => {
          const [lat, lng] = camera.coordenadas;
          return Object.assign({}, camera, {distancia: Math.round(ref.distanceTo(new LatLng(lat, lng)))});
        })
        //.filter(camera => camera.publicOnCop)
        .filter(camera => camera.distancia < 1000)
        .sort((a, b) => a.distancia - b.distancia)
        .filter(camera => camera.key !== cameraSelecionada.key)
        .slice(0, 20);
    }

    return [];
  }

  onClickCamera(camera, nextProps) {
    const key = camera.target.options.id;
    const cameraSelecionada = nextProps.cameras.find(c => c.key === key);
    this.selecionaCamera2(cameraSelecionada);
  }
  
  selecionaCamera2(camera) {
    this.props.updateVideoUrl(camera.videoUrl);
    this.props.selecionaCamera(camera);
    this.props.registerTimelineListener(camera.key);
  }

  updateMarkersLayer(nextProps) {        
    this.markerLayers.removeLayers(this.markerLayers.getLayers())
    const { filtroAlertas } = nextProps;

    nextProps.cameras
      .sort((a, b) => a.key.localeCompare(b.key))
      .forEach(camera => {
        //if(camera.publicOnCop){
          const id = camera.key;
          camera.id = id;

          const marker = (camera.state === "offline") ? MarkerCameraOff : MarkerCamera;
          
          this.markerLayers.addLayer(
            marker(camera.coordenadas, camera, undefined, camera => this.onClickCamera(camera, nextProps))
          );
        //}
      });
    
    const isPulse     = layer => layer.options.id === 'pulse-marker';
    const isTipo      = alerta => {
      var data = new Date();
      switch(filtroAlertas){
        case '1h':
          var filtro1h = data.setHours(data.getHours() - 1);
          if(alerta.timestamp > filtro1h/1000 | 0){
            return alerta;
          }
        break;
        case '24h':
          var filtro24h = data.setHours(data.getHours() - 24);
          if(alerta.timestamp > filtro24h/1000 | 0){
            return alerta;
          }
        break;
        case 'todos':
          return alerta;
        default:
          if(camelCase(filtroAlertas) === camelCase(alerta.tipo)){
            return alerta;
          }
      }
    }
    
    const alertas = nextProps.alertas.filter(alerta => isTipo(alerta));;
    const alertasAnteriores = this.markerLayers.getLayers().filter(m => !isPulse(m)).map(m => m.options.alerta);
    const entraram = differenceBy(alertas, alertasAnteriores, 'id');

    // adiciona markers.
    entraram.forEach(alerta => {
      this.markerLayers.addLayer(getPorTipo(alerta.tipo,alerta.localizacao, {id: alerta.id, alerta, endereco: alerta.endereco}, alerta.usuario));
    });

    // remove os pulse markers logo apos serem exibidos.
    setTimeout(() => {
      this.markerLayers.getLayers().map(layer => {
        if(isPulse(layer)){
          const alerta = layer.options.alerta;
          this.markerLayers.removeLayer(layer);
          this.markerLayers.addLayer(getPorTipo(alerta.tipo, alerta.localizacao, {id: alerta.id, alerta}, alerta.usuario));
        } 
      });
    }, UM_MINUTO);
  }

  componentWillReceiveProps(nextProps) {
    return super.componentWillReceiveProps(nextProps)
      .then(() => {
        const toastAlerta = nextProps.toastAlertaSelecionado.coordenadas;
        if (toastAlerta) {
          this.map.flyTo(new LatLng(toastAlerta[0], toastAlerta[1]), 18);
        }
      });
  }

  componentDidMount() {
    super.componentDidMount();
    if (this.props.location.pathname === '/marcadores') {
      this.props.history.push('/marcadores/todos');
    }
  }
}

const mapStateToProps = (state) =>  ({
  cameras: state.cameras,
  cameraSelecionada: state.cameraSelecionada,
  toastAlertaSelecionado: state.alertaToastSelecionado,
  alertas: state.alertas,
  filtroAlertas: state.filtroAlertas,
  videoUrl: state.videoUrl,
  raio: state.raio,
  localizacao: state.localizacao
});
const mapDispatchToProps = (dispatch) => bindActionCreators(actionCreators, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Marcadores);



// WEBPACK FOOTER //
// ./src/containers/Marcadores.js